/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, LeggiProgetto } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneProgettoModalLeggiProgettoComponent } from '../modal-leggi-progetto/modal-leggi-progetto.component';

@Component({
    selector: 'app-toolkit-progetto-tab-leggi-progetto',
    templateUrl: './tab-leggi-progetto.component.html',
})
export class ToolkitGestioneProgettoTabLeggiProgettoComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() datalist: DatalistAnagrafica;
    @Input() items: LeggiProgetto[] = [];

    constructor(
        private modalService: NgbModal,
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
    ) { }

    ngOnInit(): void {
        this.progettoService.leggiProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe((list: LeggiProgetto[]) => {
            this.items = list;
        });
    }
    public viewItem(item: LeggiProgetto) {
        const modal = this.modalService.open(ToolkitGestioneProgettoModalLeggiProgettoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Visualizza';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = item;
    }
    
    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneProgettoModalLeggiProgettoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.progettoService.insertLeggiProgetto(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.progettoService.leggiProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe((list: LeggiProgetto[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(leggeProgetto: LeggiProgetto) {
        const modal = this.modalService.open(ToolkitGestioneProgettoModalLeggiProgettoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = leggeProgetto;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.progettoService.updateLeggiProgetto(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.progettoService.leggiProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe((list: LeggiProgetto[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idLeggeProgetto: number) {
        this.progettoService.deleteLeggiProgetto(idLeggeProgetto).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.progettoService.leggiProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe((list: LeggiProgetto[]) => {
                    this.items = list;
                });
            }
        });
    }

}
